import { loadManifest } from 'manifestManager';
import ReactDOM from 'react-dom/client';
import 'semantic-ui-css/semantic.min.css';
import { AppWithProvider } from './App';

// ✅ preserve your original warn/error suppression
const errorStrings = {
  defaultProps: 'Support for defaultProps',
  findDOMNode: 'findDOMNode is deprecated',
  uniqueKeys: 'Each child in a list should have a unique'
};

const RootComponent = () => {
  const originalWarn = console.warn;
  console.warn = (message, ...args) => {
    let showMessage = true;
    if (typeof message === 'string') {
      Object.keys(errorStrings).forEach(key => {
        if (message.includes(errorStrings[key])) {
          showMessage = false;
        }
      });
    }
    originalWarn(message, ...args);
  };

  const originalError = console.error;
  console.error = (message, ...args) => {
    let showMessage = true;
    if (typeof message === 'string') {
      Object.keys(errorStrings).forEach(key => {
        if (message.includes(errorStrings[key])) {
          showMessage = false;
        }
      });
    }
    showMessage && originalError(message, ...args);
  };

  return <AppWithProvider />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// 🚀 Bootstrap: load manifest first, then render the app
(async function bootstrap() {
  try {
    await loadManifest(); // 🧠 <- all manifest fetching, icon fallback, caching, etc.
  } catch (err) {
    console.error('Manifest loading failed:', err);
  } finally {
    root.render(<RootComponent />);
  }
})();